var render = function render() {
  var _vm = this,
      _c = _vm._self._c;return _c('el-dialog', _vm._b({ attrs: { "visible": _vm.dialogVisible }, on: { "update:visible": function updateVisible($event) {
        _vm.dialogVisible = $event;
      } } }, 'el-dialog', _vm.dialogAttrs, false), [_c('div', { directives: [{ name: "loading", rawName: "v-loading", value: _vm.loading, expression: "loading" }], staticClass: "popover-container" }, [_c('el-schema-form', { ref: "form", attrs: { "schema": _vm.schema, "model": _vm.model, "config": _vm.formConfig, "submit-button": _vm.submitButtonAttrs, "cancel-button": _vm.cancelButtonAttrs }, on: { "cancel": _vm.close, "submit": _vm.handleSubmit } })], 1)]);
};
var staticRenderFns = [];

export { render, staticRenderFns };